var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5.01953C3.125 3.984 3.96447 3.14453 5 3.14453H6.875C7.91053 3.14453 8.75 3.984 8.75 5.01953V6.89453C8.75 7.93007 7.91053 8.76953 6.875 8.76953H5C3.96447 8.76953 3.125 7.93007 3.125 6.89453V5.01953Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 13.1445C3.125 12.109 3.96447 11.2695 5 11.2695H6.875C7.91053 11.2695 8.75 12.109 8.75 13.1445V15.0195C8.75 16.0551 7.91053 16.8945 6.875 16.8945H5C3.96447 16.8945 3.125 16.0551 3.125 15.0195V13.1445Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.01953C11.25 3.984 12.0895 3.14453 13.125 3.14453H15C16.0355 3.14453 16.875 3.984 16.875 5.01953V6.89453C16.875 7.93007 16.0355 8.76953 15 8.76953H13.125C12.0895 8.76953 11.25 7.93007 11.25 6.89453V5.01953Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.1445C11.25 12.109 12.0895 11.2695 13.125 11.2695H15C16.0355 11.2695 16.875 12.109 16.875 13.1445V15.0195C16.875 16.0551 16.0355 16.8945 15 16.8945H13.125C12.0895 16.8945 11.25 16.0551 11.25 15.0195V13.1445Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.c9867718133e995e2ba838949f1e41ee.svg";
export { ForwardRef as ReactComponent };